module.exports = __webpack_public_path__ + "static/media/Logo_beta.c0759fad.png";